<template>
  <!-- Need to add height inherit because Vue 2 don't support multiple root ele -->
    <div style="height: inherit" class="setup share-type">
        <table-and-header
            ref="table"
            :share-types-list= "shareTypes"
            :is-fetching-data= "isFetchingData"
            :data-delete-action-loading="isButtonActionLoading"
            @addNewShareType = "handleShareTypeCreateOrEdit"
            @editShareType="handleShareTypeCreateOrEdit"
            @removeShareType="removeShareType"
        />

        <create-or-edit
            v-model="isShareTypeHandlerSidebarActive"
            :share-type="shareType"
            :clear-share-type-data="clearShareTypeData"
            :data-sidebar-action-loading="isButtonActionLoading"
            @add-share-type="addShareType"
            @update-share-type="updateShareType"
        />
    </div>
</template>

<script>
import {
    ref, watch, computed
} from '@vue/composition-api';

import { formatDate, avatarText } from '@core/utils/filter';

import { useRouter } from '@core/utils/utils';
import ShareType from '@/models/ShareType';
import { errorToast, successToast } from "@/views/helpers/toast";
import { SOMETHING_WENT_WRONG } from '@/constants/errors';
import {
    SHARE_TYPE_CREATE_SUCCESS,
    SHARE_TYPE_UPDATE_SUCCESS,
    SHARE_TYPE_DELETE_SUCCESS,
} from '@/constants/success';
import TableAndHeader from './TableAndHeader.vue';
import CreateOrEdit from './CreateOrEdit.vue';

export default {
    components: {
        // App SFC
        CreateOrEdit,
        TableAndHeader,
    },

    setup() {
        const { route, router } = useRouter();
        const routeParams = computed(() => route.value.params);

        watch(routeParams, () => {
            // eslint-disable-next-line no-use-before-define
            fetchShareTypes();
        });

        const shareTypes = ref([]);
        const isFetchingData = ref(false);
        const isShareTypeHandlerSidebarActive = ref(false);
        const isButtonActionLoading = ref(false);
        const table = ref(null);

        const shareTypeBluePrint = {
            id: undefined,
            name: undefined,
        };

        const shareType = ref(JSON.parse(JSON.stringify(shareTypeBluePrint)));

        const clearShareTypeData = () => {
            shareType.value = JSON.parse(JSON.stringify(shareTypeBluePrint));
        };

        const addShareType = data => {
            isButtonActionLoading.value = true;

            ShareType
                .create(data)
                .then(payload => {
                    shareTypes.value.push(payload);

                    successToast(SHARE_TYPE_CREATE_SUCCESS);
                    isShareTypeHandlerSidebarActive.value = false;
                    isButtonActionLoading.value = false;

                    setTimeout(() => {
                        clearShareTypeData();
                    }, 350);
                })
                .catch(e => {
                    errorToast(SOMETHING_WENT_WRONG);
                    isButtonActionLoading.value = false;
                    console.error(
                        "error while trying to store share type in setup",
                        e
                    );
                });
        };

        const removeShareType = data => {
            isButtonActionLoading.value = true;

            ShareType
                .delete(data.item.id, data.item)
                .then(() => {
                    shareTypes.value = shareTypes.value.filter( exitingShareType =>
                        // eslint-disable-next-line no-use-before-define
                        exitingShareType.id !== data.item.id
                    );

                    successToast(SHARE_TYPE_DELETE_SUCCESS);
                    table.value.$refs.modal.$refs.confirmationModal.hide();
                    isButtonActionLoading.value = false;
                })
                .catch(e => {
                    let error = '';
                    if (e.response)
                        error = e.response.data.message;
                    else
                        error = e.message;

                    errorToast(error);
                    isButtonActionLoading.value = false;
                });
        };

        const updateShareType = data => {
            isButtonActionLoading.value = true;

            ShareType.update(data.id, data)
                .then(() => {
                    shareTypes.value.forEach(existingShareType => {
                        if (existingShareType.id === data.id) {
                            Object.keys(shareTypeBluePrint).forEach(key => {
                                // eslint-disable-next-line no-param-reassign
                                existingShareType[key] = data[key];
                            });
                        }
                    });

                    successToast(SHARE_TYPE_UPDATE_SUCCESS);
                    isShareTypeHandlerSidebarActive.value = false;
                    isButtonActionLoading.value = false;
                })
                .catch(e => {
                    errorToast(SOMETHING_WENT_WRONG);
                    isButtonActionLoading.value = false;
                    console.error(
                        "error while trying to update share type in setup",
                        e
                    );
                });
        };

        const perfectScrollbarSettings = {
            maxScrollbarLength: 150,
        };

        // eslint-disable-next-line no-use-before-define
        const updateRouteQuery = val => {
            const currentRouteQuery = JSON.parse(JSON.stringify(route.value.query));

            if (val) currentRouteQuery.q = val;
            else delete currentRouteQuery.q;

            router.replace({ name: route.name, query: currentRouteQuery });
        };

        const fetchShareTypes = async() => {
            isFetchingData.value = true;
            shareTypes.value = [];

            const shareTypeLists = await ShareType.all();
            shareTypeLists.forEach(dataShareType => {
                shareTypes.value.push({
                    id  : dataShareType.id,
                    name: dataShareType.name,
                });
            });

            isFetchingData.value = false;
        };

        fetchShareTypes();

        const handleShareTypeCreateOrEdit = toEditShareType => {
            if(toEditShareType === 'create') {
                shareType.value = shareTypeBluePrint;
            }
            else shareType.value = toEditShareType.item;

            isShareTypeHandlerSidebarActive.value = true;
        };

        return {
            shareType,
            shareTypes,
            removeShareType,
            addShareType,
            updateShareType,
            clearShareTypeData,
            fetchShareTypes,
            perfectScrollbarSettings,
            updateRouteQuery,

            // Click Handler
            handleShareTypeCreateOrEdit,

            // Filters
            formatDate,
            avatarText,
            isFetchingData,
            table,

            isShareTypeHandlerSidebarActive,
            isButtonActionLoading
        };
    },
};
</script>

<style lang="scss">
@import "~@core/scss/base/pages/app-todo.scss";
</style>
